import "./App.css";
import { useState } from "react";

import generation1 from "./data/generation1.json"
import generation2 from "./data/generation2.json"
import generation3 from "./data/generation3.json"
import generation4 from "./data/generation4.json"
import generation5 from "./data/generation5.json"
import generation6 from "./data/generation6.json"
import generation7 from "./data/generation7.json"
import generation8 from "./data/generation8.json"
import generation9 from "./data/generation9.json"
import generation10 from "./data/generation10.json"

import { alolaIDs, arceusIDs, charmillyIDs, fabulousIDs, galarIDs, gen10IDs, gen1IDs, gen2IDs, gen3IDs, gen4IDs, gen5IDs, gen6IDs, gen7IDs, gen8IDs, gen9IDs, gigamaxIDs, hisuiIDs, legendaryFabulousIDs, legendaryIDs, megaIDs, metenoIDs, paldeaIDs, paradoxIDs, pikachuClonesIDs, pikachuFormsIDs, pokedexIDs, prismillonIDs, regionalIDs, silvallieIDs, ultraBeastsIDs, zarbiIDs } from "./Modes";

import { tr } from "./i18n/i18n";
import t from "./i18n/i18n.json";

function App() {

    const params = new URLSearchParams(window.location.search)
    const mode = params.get("mode")
    const lang = params.get("lang")
    console.log(mode)

    const [pokemonList, setPokemonList] = useState(() => {
        let list = [
            ...generation1, ...generation2, ...generation3, ...generation4,
            ...generation5, ...generation6, ...generation7, ...generation8,
            ...generation9, ...generation10
        ]

        if (mode == "full") {
            list = list
        } else if (mode == "gen1") {
            list = list.filter(p => gen1IDs.includes(p.id))
        } else if (mode == "gen2") {
            list = list.filter(p => gen2IDs.includes(p.id))
        } else if (mode == "gen3") {
            list = list.filter(p => gen3IDs.includes(p.id))
        } else if (mode == "gen4") {
            list = list.filter(p => gen4IDs.includes(p.id))
        } else if (mode == "gen5") {
            list = list.filter(p => gen5IDs.includes(p.id))
        } else if (mode == "gen6") {
            list = list.filter(p => gen6IDs.includes(p.id))
        } else if (mode == "gen7") {
            list = list.filter(p => gen7IDs.includes(p.id))
        } else if (mode == "gen8") {
            list = list.filter(p => gen8IDs.includes(p.id))
        } else if (mode == "gen9") {
            list = list.filter(p => gen9IDs.includes(p.id))
        } else if (mode == "gen10") {
            list = list.filter(p => gen10IDs.includes(p.id))
        } else if (mode == "pikachuForms") {
            list = list.filter(p => pikachuFormsIDs.includes(p.id))
        } else if (mode == "pikachuClones") {
            list = list.filter(p => pikachuClonesIDs.includes(p.id))
        } else if (mode == "mega") {
            list = list.filter(p => megaIDs.includes(p.id))
        } else if (mode == "gigantamax") {
            list = list.filter(p => gigamaxIDs.includes(p.id))
        } else if (mode == "arceus") {
            list = list.filter(p => arceusIDs.includes(p.id))
        } else if (mode == "silvallie") {
            list = list.filter(p => silvallieIDs.includes(p.id))
        } else if (mode == "prismillon") {
            list = list.filter(p => prismillonIDs.includes(p.id))
        } else if (mode == "charmilly") {
            list = list.filter(p => charmillyIDs.includes(p.id))
        } else if (mode == "regional") {
            list = list.filter(p => regionalIDs.includes(p.id))
        } else if (mode == "alola") {
            list = list.filter(p => alolaIDs.includes(p.id))
        } else if (mode == "galar") {
            list = list.filter(p => galarIDs.includes(p.id))
        } else if (mode == "hisui") {
            list = list.filter(p => hisuiIDs.includes(p.id))
        } else if (mode == "paldea") {
            list = list.filter(p => paldeaIDs.includes(p.id))
        } else if (mode == "legendary") {
            list = list.filter(p => legendaryIDs.includes(p.id))
        } else if (mode == "fabulous") {
            list = list.filter(p => fabulousIDs.includes(p.id))
        } else if (mode == "legendaryFabulous") {
            list = list.filter(p => legendaryFabulousIDs.includes(p.id))
        } else if (mode == "zarbi") {
            list = list.filter(p => zarbiIDs.includes(p.id))
        } else if (mode == "meteno") {
            list = list.filter(p => metenoIDs.includes(p.id))
        } else if (mode == "ultraBeasts") {
            list = list.filter(p => ultraBeastsIDs.includes(p.id))
        } else if (mode == "paradox") {
            list = list.filter(p => paradoxIDs.includes(p.id))
        } else {
            list = list.filter(p => pokedexIDs.includes(p.id))
        }

        return list.map(p => ({ ...p, elo: 1000 }))
    })

    const K = 32

    let nextPokemon1 = pokemonList[Math.floor(Math.random() * pokemonList.length)]
    let nextPokemon2 = pokemonList[Math.floor(Math.random() * pokemonList.length)]

    while (nextPokemon1 == nextPokemon2) {
        console.log('pokemon1', nextPokemon1, 'pokemon2', nextPokemon2)
        nextPokemon2 = pokemonList[Math.floor(Math.random() * pokemonList.length)]
    }

    // const [pokemon1, setPokemon1] = pokemonList[Math.floor(Math.random() * pokemonList.length)]
    const [pokemon1, setPokemon1] = useState(nextPokemon1)
    const [pokemon2, setPokemon2] = useState(nextPokemon2)

    const [c, setC] = useState(1) // count

    const updateELO = (pokemon1, pokemon2, winner, loser) => {
        const expectedWinner = 1 / (1 + Math.pow(10, ((loser.elo - winner.elo)) / 400))
        const expectedLoser = 1 / (1 + Math.pow(10, ((winner.elo - loser.elo)) / 400))

        winner.elo += Math.ceil(K * (1 - expectedWinner))
        loser.elo += Math.ceil(K * (0 - expectedLoser))

        console.log('winner elo', winner.elo)
        console.log('loser  elo', loser.elo)

        let nextPokemon1 = pokemonList[Math.floor(Math.random() * pokemonList.length)]
        let nextPokemon2 = pokemonList[Math.floor(Math.random() * pokemonList.length)]

        while (nextPokemon1 == nextPokemon2) {
            console.log('pokemon1', nextPokemon1, 'pokemon2', nextPokemon2)
            nextPokemon2 = pokemonList[Math.floor(Math.random() * pokemonList.length)]
        }

        setPokemon1(nextPokemon1);
        setPokemon2(nextPokemon2);

        setPokemonList(pokemonList.sort((p1, p2) => p1.elo < p2.elo ? 1 : -1))

        setC(c + 1) // increase count
    }

    return (
        <div className="App">

            <main>
                 
                <section>
                    <h1>{tr(t.title)}</h1>
                    {/* <h1>What is my favorite Pokémon???</h1>
                    <h1>Was ist mein Lieblings-Pokémon???</h1> */}
                    <p className="description"> {tr(t.description)}</p>
                    {/* <p className="description">Compare Pokémon two at a time to reveal your true favorite Pokémon! With each choice, the ranking evolves thanks to an ELO-inspired scoring system. Little by little, your personal ranking starts to take shape. But be warned: it can take A LOT OF TIME to build the full ranking, so don’t overthink it and quickly choose the one you prefer!</p>
                    <p className="description">Vergleiche Pokémon immer zu zweit, um dein wahres Lieblings-Pokémon herauszufinden! Mit jeder Entscheidung verändert sich die Rangliste dank eines vom ELO-System inspirierten Bewertungssystems. Nach und nach entsteht dein persönliches Ranking. Aber Vorsicht: Es kann SEHR VIEL ZEIT dauern, das komplette Ranking zu erstellen, also denk nicht zu lange nach und wähle schnell das Pokémon, das dir besser gefällt! !</p> */}

                    <div className="modes">
                        <h2>{tr(t.choice)} {c}</h2>

                        <div id="pokemon-selection-container">
                            <div onClick={() => updateELO(pokemon1, pokemon2, pokemon1, pokemon2)}>
                                <img src={`assets/${pokemon1.generation}/${pokemon1.id}.webp`} alt={pokemon1.id} />
                                <div className="name">
                                    <span><b>#{String(pokemon1.number).padStart(4, '0')}</b></span>
                                    <span className="pokemon-name">{tr(pokemon1.names)}</span>
                                </div>
                            </div>

                            <div onClick={() => updateELO(pokemon1, pokemon2, pokemon2, pokemon1)}>
                                <img src={`assets/${pokemon2.generation}/${pokemon2.id}.webp`} alt={pokemon2.id} />
                                <div className="name">
                                    <span><b>#{String(pokemon2.number).padStart(4, '0')}</b></span>
                                    <span className="pokemon-name">{tr(pokemon2.names)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    

                    <aside>
                        <p>Go to: <a href="#modes-anchor">Modes / Language</a></p>
                        <div className="pokemon-aside">
                            <span><b></b></span>
                            <span><b> {tr(t.rank)} </b></span>
                            <span><b> {tr(t.score)} </b></span>
                            <span><b> {tr(t.no)} </b></span>
                            <span><b> {tr(t.name)} </b></span>
                        </div>
                        {pokemonList.map((pokemon, index) => {
                            // <div key={index}>#{pokemon.number}. {pokemon.names.fr} | {pokemon.elo}</div>
                            return <div key={index} className="pokemon-aside">
                                <span><img src={`assets/${pokemon.generation}/${pokemon.id}.webp`} /></span>
                                <span>{index+1}</span>
                                <span>{pokemon.elo}</span>
                                <span>#{String(pokemon.number).padStart(4, '0')}</span>
                                <span>{tr(pokemon.names)}</span>
                            </div>
                        })}
                    </aside>
                    

                    <div className="modes">
                        <h2 id="modes-anchor">Modes</h2>
                        <p><span className="red">{tr(t.warning)}</span></p>
                        <div className="links">
                            <a 
                                className={mode == "full" && "current"} 
                                href={"?lang="+lang+"&mode=full"}
                            > {tr(t.full)} </a>
                            <a 
                                className={mode == "pokedex" && "current"} 
                                href={"?lang="+lang+"&mode=pokedex"}
                            > {tr(t.pokedex)} </a>
                            <a 
                                className={mode == "gen1" && "current"} 
                                href={"?lang="+lang+"&mode=gen1"}
                            > {tr(t.gen1)} </a>
                            <a 
                                className={mode == "gen2" && "current"} 
                                href={"?lang="+lang+"&mode=gen2"}
                            > {tr(t.gen2)} </a>
                            <a 
                                className={mode == "gen3" && "current"} 
                                href={"?lang="+lang+"&mode=gen3"}
                            > {tr(t.gen3)} </a>
                            <a 
                                className={mode == "gen4" && "current"} 
                                href={"?lang="+lang+"&mode=gen4"}
                            > {tr(t.gen4)} </a>
                            <a 
                                className={mode == "gen5" && "current"} 
                                href={"?lang="+lang+"&mode=gen5"}
                            > {tr(t.gen5)} </a>
                            <a 
                                className={mode == "gen6" && "current"} 
                                href={"?lang="+lang+"&mode=gen6"}
                            > {tr(t.gen6)} </a>
                            <a 
                                className={mode == "gen7" && "current"} 
                                href={"?lang="+lang+"&mode=gen7"}
                            > {tr(t.gen7)} </a>
                            <a 
                                className={mode == "gen8" && "current"} 
                                href={"?lang="+lang+"&mode=gen8"}
                            > {tr(t.gen8)} </a>
                            <a 
                                className={mode == "gen9" && "current"} 
                                href={"?lang="+lang+"&mode=gen9"}
                            > {tr(t.gen9)} </a>
                            <a 
                                className={mode == "gen10" && "current"} 
                                href={"?lang="+lang+"&mode=gen10"}
                            > {tr(t.gen10)} </a>
                            <a 
                                className={mode == "pikachuForms" && "current"} 
                                href={"?lang="+lang+"&mode=pikachuForms"}
                            > {tr(t.pikachu_appearences)} </a>
                            <a 
                                className={mode == "pikachuClones" && "current"} 
                                href={"?lang="+lang+"&mode=pikachuClones"}
                            > {tr(t.pikachu_clones)} </a>
                            <a 
                                className={mode == "mega" && "current"} 
                                href={"?lang="+lang+"&mode=mega"}
                            > {tr(t.mega_evolutions)} </a>
                            <a 
                                className={mode == "gigantamax" && "current"} 
                                href={"?lang="+lang+"&mode=gigantamax"}
                            > {tr(t.gigamax)} </a>
                            <a 
                                className={mode == "zarbi" && "current"} 
                                href={"?lang="+lang+"&mode=zarbi"}
                            > {tr(t.unown)} </a>
                            <a 
                                className={mode == "arceus" && "current"} 
                                href={"?lang="+lang+"&mode=arceus"}
                            > {tr(t.arceus)} </a>
                            <a 
                                className={mode == "prismillon" && "current"} 
                                href={"?lang="+lang+"&mode=prismillon"}
                            > {tr(t.vivillon)} </a>
                            <a 
                                className={mode == "silvallie" && "current"} 
                                href={"?lang="+lang+"&mode=silvallie"}
                            > {tr(t.silvally)} </a>
                            <a 
                                className={mode == "meteno" && "current"} 
                                href={"?lang="+lang+"&mode=meteno"}
                            > {tr(t.minior)} </a>
                            <a 
                                className={mode == "charmilly" && "current"} 
                                href={"?lang="+lang+"&mode=charmilly"}
                            > {tr(t.vivillon)} </a>
                            <a 
                                className={mode == "regional" && "current"} 
                                href={"?lang="+lang+"&mode=regional"}
                            > {tr(t.regional)} </a>
                            <a 
                                className={mode == "alola" && "current"} 
                                href={"?lang="+lang+"&mode=alola"}
                            > {tr(t.alola)} </a>
                            <a 
                                className={mode == "galar" && "current"} 
                                href={"?lang="+lang+"&mode=galar"}
                            > {tr(t.galar)} </a>
                            <a 
                                className={mode == "hisui" && "current"} 
                                href={"?lang="+lang+"&mode=hisui"}
                            > {tr(t.hisui)} </a>
                            <a 
                                className={mode == "paldea" && "current"} 
                                href={"?lang="+lang+"&mode=paldea"}
                            > {tr(t.paldea)} </a>
                            <a 
                                className={mode == "legendary" && "current"} 
                                href={"?lang="+lang+"&mode=legendary"}
                            > {tr(t.legendary)} </a>
                            <a 
                                className={mode == "fabulous" && "current"} 
                                href={"?lang="+lang+"&mode=fabulous"}
                            > {tr(t.mythical)} </a>
                            <a 
                                className={mode == "legendaryFabulous" && "current"} 
                                href={"?lang="+lang+"&mode=legendaryFabulous"}
                            > {tr(t.legendary_mythical)} </a>
                            <a 
                                className={mode == "ultraBeasts" && "current"} 
                                href={"?lang="+lang+"&mode=ultraBeasts"}
                            > {tr(t.ultra_beasts)} </a>
                            <a 
                                className={mode == "paradox" && "current"} 
                                href={"?lang="+lang+"&mode=paradox"}
                            > {tr(t.paradox)} </a>
                        </div>
                    </div>

                    
                    <div className="modes">
                        <h2>Language</h2>
                        <div className="links">
                            <a 
                                className={lang == "fr" && "current"} 
                                href={"?mode="+mode+"&lang=fr"}
                            > Français </a>
                            <a 
                                className={lang == "en" && "current"} 
                                href={"?mode="+mode+"&lang=en"}
                            > English </a>
                            <a 
                                className={lang == "de" && "current"} 
                                href={"?mode="+mode+"&lang=de"}
                            > Deutsche </a>
                        </div>
                    </div>
                </section>

                <aside>
                    <div className="pokemon-aside">
                        <span><b></b></span>
                        <span><b> {tr(t.rank)} </b></span>
                        <span><b> {tr(t.score)} </b></span>
                        <span><b> {tr(t.no)} </b></span>
                        <span><b> {tr(t.name)} </b></span>
                    </div>
                    {pokemonList.map((pokemon, index) => (
                        // <div key={index}>#{pokemon.number}. {pokemon.names.fr} | {pokemon.elo}</div>
                        <div key={index} className="pokemon-aside">
                            <span><img src={`assets/${pokemon.generation}/${pokemon.id}.webp`} /></span>
                            <span>{index+1}</span>
                            <span>{pokemon.elo}</span>
                            <span>#{String(pokemon.number).padStart(4, '0')}</span>
                            <span>{tr(pokemon.names)}</span>
                        </div>
                    ))}
                </aside>
            </main>
        </div>
    );
}

export default App;
